<template>
    <b-card class="shadow p-4">
        <b-row>
            <b-col>

                <div class="d-flex flex-column w-100">
                    <div class="d-flex flex-grow-1"><span class="h2">{{ title }}</span></div>

                    <div class="d-flex flex-grow-1 mb-3">
                        <div class="d-flex justify-content-center flex-grow-0 flex-wrap p-2">
                            <b-form-radio v-model="breakdownType" @change="onBreakdownTypeChange" name="euthanasia-breakdown-types" value="1" class="mr-4">По времени</b-form-radio>
                            <b-form-radio v-if="canSelectContractor()"  v-model="breakdownType" @change="onBreakdownTypeChange" name="euthanasia-breakdown-types" value="3" class="mr-4">По исполнителям</b-form-radio>
                            <b-form-radio v-model="breakdownType" @change="onBreakdownTypeChange" name="euthanasia-breakdown-types" value="4">По основаниям для эвтаназии</b-form-radio>
                        </div>
                    </div>

                    <div class="col-xs-12">
                            <transition name="fade" mode="out-in">
                                <div v-if="chartDataInitialized">
                                    <EventStatisticsBar :chart-data="chartData" :is-legend-visible="false" style="max-width: 100%; height: 400px" class="mb-4"/>
                                    <offscreen-chart :title="title">
                                        <template #subtitle>
                                            <span>{{ getOffscreenSubtitle() }}</span>
                                        </template>
                                        <template #chart>
                                            <EventStatisticsBar :chart-data="chartData" :is-legend-visible="false" class="mb-4" style="width: 900px; height: 600px"/>
                                        </template>
                                    </offscreen-chart>
                                    <StatisticsTable :data="chartData"  @on-value-clicked="onTableValueClicked"/>
                                </div>
                                <div v-else class="d-flex w-100 align-items-center justify-content-center" style="max-width: 100%; height: 400px">
                                    <b-spinner variant="info"/>
                                </div>
                            </transition>
                    </div>
                </div>
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
import {EventStatisticsMixin} from "@/pages/Statistics/eventStatisticsMixin";
import {EventKind} from "@/pages/AppPages/Events/event";
import EventStatisticsLine from "@/pages/Statistics/EventStatisticsLine";
import {mapGetters} from "vuex";
import StatisticsTable from "@/pages/Statistics/StatisticsTable.vue";
import EventStatisticsBar from "@/pages/Statistics/EventStatisticsBar";
import OffscreenChart from "@/pages/Statistics/OffscreenChart.vue";
import {TableActions} from "@/store/tables/constants";

export default {
    name: "EuthanasiaStatistics",
    components: {OffscreenChart, EventStatisticsBar, StatisticsTable, EventStatisticsLine},
    mixins: [EventStatisticsMixin],
    computed: {
        ...mapGetters(['isInController', 'isMunicipalController', 'isInContractor',
            'hasMunicipalityRestrictions', 'userOrganizationMunicipalities', 'isVetControl']),
        title() {
            return 'Проведенные мероприятия эвтаназии'
        }
    },
    methods: {
        canSelectContractor() {
            return this.isMunicipalController || this.isInController || this.isVetControl
        },
        getExtraParams() {
            return [
                { query: { 'kind': EventKind.EUTHANASIA }, label: 'Животные, подвергнутые эвтаназии', filterLabel: 'Эвтаназия', borderColor: '#595959', backgroundColor: '#595959' },
            ];
        },
        onTableValueClicked(value) {
            const rowParams = value.rowParams;
            const colParams = value.colParams;
            let filters = [
                {'key': 'kind', 'value': rowParams['kind'], 'label': value.filterLabel}
            ]

            let dateStart = null;
            let dateEnd = null;
            if (rowParams['execution_month']) {
                const m = parseInt(rowParams['execution_month']);
                const y = parseInt(rowParams['execution_year'] ? rowParams['execution_year'] : new Date().getFullYear().toString());
                const newDate = new Date(y, m, 0)
                dateStart = `01.${m}.${y}`;
                dateEnd = `${newDate.getDate()}.${newDate.getMonth() + 1}.${y}`;
            } else if (rowParams['execution_year']) {
                dateStart = '01.01.' + rowParams['execution_year'];
                dateEnd = '31.12.' + rowParams['execution_year'];
            }
            if (rowParams['execution_date_from']) {
                dateStart = rowParams['execution_date_from']
            }
            if (rowParams['execution_date_to']) {
                dateEnd = rowParams['execution_date_to']
            }
            if (colParams && (colParams['date_start'] || colParams['date_end'])) {
                if (!rowParams['cumulative']) {
                    dateStart = colParams['date_start']
                }
                if (colParams['date_end']) {
                    dateEnd = colParams['date_end']
                }
            }
            if (dateStart) {
                filters.push({'key':'execution_date_from', 'value': dateStart, 'label': 'Дата проведения не ранее ' + dateStart})
            }
            if (dateEnd) {
                filters.push({'key': 'execution_date_to', 'value': dateEnd, 'label': 'Дата проведения не позднее ' + dateEnd})
            }


            if (colParams['euthanasia_reason']) {
                filters.push({'key': 'euthanasia_reason', 'value': colParams['euthanasia_reason'], 'label': colParams['name']})
            }

            if (rowParams['municipality']) {
                filters.push({'key': 'municipality', 'value': rowParams['municipality'], 'label': rowParams['municipality_name']})
            }

            if (colParams['contractor']) {
                filters.push({'key': 'executor', 'value': colParams['contractor'], 'label': colParams['name']})
            } else {
                if (rowParams['executor']) {
                    filters.push({'key': 'executor', 'value': rowParams['executor'], 'label': rowParams['executor_name']})
                }
            }
            const tableName = 'common-events-table';
            this.$store.dispatch(TableActions.TABLE_SET_CURRENT_PAGE,
                { name: tableName, page: 1 })
                .then(() => {
                    return this.$store.dispatch(TableActions.TABLE_CHANGE_FILTERS,
                        { name: tableName, filterData: filters })
                })
                .then(() => {
                    window.open('/events', '_blank').focus();
                });
        },
        getOffscreenSubtitle() {
            let subtitle = '';
            const cumulative = Object.keys(this.commonQueryParams).length > 0 && this.commonQueryParams['cumulative'];
            if (cumulative) {
                subtitle += 'Нарастающим итогом '
            }

            let subtitleBreakdown = ''
            if (parseInt(this.breakdownType) === 1) {
                subtitleBreakdown = 'За '
            } else if (parseInt(this.breakdownType) === 3) {
                subtitleBreakdown = 'По исполнителям'
            } else if (parseInt(this.breakdownType) === 4) {
                subtitleBreakdown = 'По основаниям для эвтаназии'
            }

            if (cumulative) {
                subtitleBreakdown = subtitleBreakdown.toLowerCase()
            }

            subtitle += subtitleBreakdown


            if (Object.keys(this.commonQueryParams).length > 0 && parseInt(this.breakdownType) !== 1) {
                subtitle += '\n'
            }
            if (this.commonQueryParams['execution_month']) {
                let d = new Date()
                d.setMonth(this.commonQueryParams['execution_month'] - 1)
                subtitle += d.toLocaleString('ru-RU', { month: "long" }) + ', '
            }
            if (this.commonQueryParams['execution_year']) {
                subtitle += this.commonQueryParams['execution_year'] + ' г.'
            }
            if (this.commonQueryParams['execution_date_from'] && this.commonQueryParams['execution_date_to']) {
                subtitle += 'период c ' + this.commonQueryParams['execution_date_from'] + ' по ' + this.commonQueryParams['execution_date_to']
            }
            if (this.commonQueryParams['execution_date_from'] && !this.commonQueryParams['execution_date_to']) {
                subtitle += 'период c ' + this.commonQueryParams['execution_date_from'] + ' по н. вр.'
            }
            if (!this.commonQueryParams['execution_date_from'] && this.commonQueryParams['execution_date_to']) {
                subtitle += 'период c н. вр.' + this.commonQueryParams['execution_date_from'] + ' по ' + this.commonQueryParams['execution_date_to']
            }
            if (this.commonQueryParams['municipality_name']) {
                subtitle += ', ' + this.commonQueryParams['municipality_name']
            }
            if (this.commonQueryParams['executor_name']) {
                subtitle += ', ' + this.commonQueryParams['executor_name']
            }
            return subtitle
        }
    }
}
</script>

<style scoped>

</style>